import React from 'react';
import { useSalon } from '../context/SalonContext';
import './LocationMap.css';

// Fallbacks
const defaultName = "Studio Ambre";
const defaultAddress = "46 Av. du Commandant Parisot, 32600 L'Isle-Jourdain";
const defaultPhone = "06 41 30 78 72";
const defaultMapUrl = "https://www.google.com/maps/place/Coif'%20Esp%C3%A9/@43.613810871104,1.0804604761215788,17z/data=!3m1!4b1!4m6!3m5!1s0x12a94f39e8b0fcdb:0xa5b08e6eeacd6369!8m2!3d43.613810871104!4d1.0804604761215788!16s%2Fg%2F1q62d5qjx";

function LocationMap() {
  const { salonInfos } = useSalon();

  const name = salonInfos?.name || defaultName;
  const address = salonInfos?.address || defaultAddress;
  const phone = salonInfos?.phone || defaultPhone;
  const mapUrl = salonInfos?.google_maps_url || defaultMapUrl;

  const cleanPhone = phone.replace(/\s/g, '').replace(/\./g, '');

  return (
    <div className="location-map-container">
      <h3 className="location-title">Où nous trouver ?</h3>
      <div className="address-container">
        <p className="address-text">
          <strong>{name}</strong><br />
          <span style={{ whiteSpace: 'pre-line' }}>{address}</span><br />
          Téléphone : <a href={`tel:${cleanPhone}`} className="phone-number-link">{phone}</a>
        </p>
        <a
          href={mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="map-link-button"
        >
          Voir sur Google Maps
        </a>
      </div>

      <div className="map-placeholder">
        {/* Note: L'iframe est statique pour garantir l'affichage. Pour le changer dynamiquement il faudrait une API Key Google Maps */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2888.6508505533657!2d1.0804604761215788!3d43.613810871104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a94f39e8b0fcdb%3A0xa5b08e6eeacd6369!2sCoif'%20Esp%C3%A9!5e0!3m2!1sfr!2sfr!4v1758628028050!5m2!1sfr!2sfr"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title={`Carte de localisation ${name}`}>
        </iframe>
      </div>
    </div>
  );
}

export default LocationMap;